// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__3ARrs","loader":"Table_loader__3PjB5","table":"Table_table__1P__R","row":"Table_row__K21kQ","col":"Table_col__3xnzD","foot":"Table_foot__35Gi4"};